import React from 'react';

import { HelperMessage } from '@atlaskit/form';
import { useAssociatedServices } from 'src/services/associatedServices';

import pd from 'src/lib/api/pagerduty';

import SelectBase from './SelectBase';

function serviceToOption(service) {
  return ({
    label: service.summary,
    value: service.id,
    fromService: service.fromService,
  });
}

class SelectServicesView extends React.Component {
  requestNo = 0;

  loadOptions = async (text) => {
    this.requestNo++;

    const {
      allowAllServices = true,
      associatedServices,
    } = this.props;

    let allServices = [];
    if (allowAllServices) {
      allServices = await pd.getPagerDutyServices(text).then(res => res.services.map(serviceToOption));
    } else if (!text) {
      allServices = [{
        isDisabled: true,
        label: <HelperMessage>Please login to access other services</HelperMessage>,
        value: 'not-available-1',
      }];
    }

    const associated = associatedServices.services
      .filter(s => s.summary.toLowerCase().includes(text.toLowerCase()))
      .map(s => ({ ...(serviceToOption(s)), associatedWithCurrentProject: true }));

    if (this.requestNo === 1 && associated.length === 1) {
      this.props.onChange({ target: { value: associated[0], name: this.props.name } });
    }

    if (associatedServices.services.length === 0 && !text) {
      associated.push({
        isDisabled: true,
        label: <HelperMessage>Can not find services associated with current Project</HelperMessage>,
        value: 'not-available-2'
      });
    }

    allServices = allServices.filter(everyService => associated.every(s => s.value !== everyService.value));

    const res = [
      {
        label: 'Services linked to current project',
        options: associated
      },
      {
        label: 'Other services',
        options: allServices
      }
    ];

    if (res[0].options.length === 1 && res[0].options[0].value === 'not-available-2') {
      res.reverse();
    }

    return res;
  };

  render() {
    const className = 'services-dropdown';
    const newProps = { className, loadOptions: this.loadOptions, ...this.props };
    return <SelectBase {...newProps}/>;
  }
}

const SelectServices = (props) => {
  const associatedServices = useAssociatedServices();
  return <SelectServicesView associatedServices={associatedServices} {...props}/>;
};
export default SelectServices;
